import React from 'react';

import { PageBase } from '../../../dtos';

import { PageItemContainer } from './styles';

export type PageItemCollapsedProps =
  React.AnchorHTMLAttributes<HTMLAnchorElement> & {
    page: PageBase;
  };

export const PageItemCollapsed: React.FC<PageItemCollapsedProps> = ({
  page,
  ...props
}) => {
  return (
    <PageItemContainer href={page.url} {...props}>
      <span title={page.name}>{page.name}</span>
    </PageItemContainer>
  );
};
